import React from 'react';
import CustomMedia from 'util/custom-media-query';
import FormDialogrenderer from './FormDialogRenderer';
import i18n from 'i18n';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import Button from 'components/common/Button';
import SelectField from 'components/common/SelectField';
import TextField from 'components/common/TextField';
import RadioField from 'components/OrderAggregators/components/RadioField';
import DatepickerField from 'components/common/DatepickerField';
import { PreferredTimeOptions } from 'constants/preferred-delivery-time';
import { required } from 'validation/validators';
import DeliveryPreferred from 'constants/delivery-preferred';

const resetValues = (value, change, datepickerMin) => {
  if (value === DeliveryPreferred.on) {
    change(
      'preferredDate',
      datepickerMin.format(i18n.t('common:dateFormat.default'))
    );
    change('preferredTime', PreferredTimeOptions[0].value);
  }
};

const DialogBody = ({ form, datepickerMin, datepickerMax }) => (
  <div className="delivery">
    <div className="fields-container">
      <React.Fragment>
        <RadioField
          name="deliveryPreferred"
          labels={[
            i18n.t('orderAggregators:payment:delivery.preferredOff'),
            i18n.t('orderAggregators:payment:delivery.preferredOn')
          ]}
          values={[DeliveryPreferred.off, DeliveryPreferred.on]}
          onChange={v =>
            resetValues(v.target.value, form.change, datepickerMin)
          }
        />

        {form.getState().values.deliveryPreferred === DeliveryPreferred.on ? (
          <React.Fragment>
            <DatepickerField
              name="preferredDate"
              label={i18n.t('orderAggregators:payment:delivery.preferredDate')}
              required={true}
              minDate={datepickerMin.format(
                i18n.t('common:dateFormat.default')
              )}
              maxDate={datepickerMax.format(
                i18n.t('common:dateFormat.default')
              )}
              validate={value => required(value)}
              disable={i18n.t('notice:delivery.disable', { returnObjects: true })}
            />
            <SelectField
              name="preferredTime"
              label={i18n.t('orderAggregators:payment:delivery.preferredTime')}
              required={true}
              options={PreferredTimeOptions}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <TextField
              name="preferredDate"
              label={i18n.t('orderAggregators:payment:delivery.preferredDate')}
              value=""
              disabled={true}
            />
            <TextField
              name="preferredTime"
              label={i18n.t('orderAggregators:payment:delivery.preferredTime')}
              value=""
              disabled={true}
            />
          </React.Fragment>
        )}

        <div className="description">
          <div className="description-label">
            {i18n.t('orderAggregators:payment:delivery.aboutDelivery')}
          </div>
          <ul>
            <li>
              {i18n.t('orderAggregators:payment:delivery.aboutDeliveryNote1')}
            </li>
          </ul>
        </div>

        <div className="description">
          <div className="description-label">
            {i18n.t('orderAggregators:payment:delivery.aboutReturn')}
          </div>
          {i18n.t('orderAggregators:payment:delivery.aboutReturnNote')}
        </div>
      </React.Fragment>
    </div>
  </div>
);

const DialogFooter = ({ handleSubmit, invalid }) => (
  <div className="footer-btn-wrapper">
    <Button
      buttonType="B"
      type="button"
      onClick={handleSubmit}
      disabled={invalid}
    >
      {i18n.t('common:save')}
    </Button>
  </div>
);

const DeliveryDialog = ({
  className,
  onSubmit,
  dialogRef,
  datepickerMin,
  datepickerMax,
  deliveries
}) => (
  <div className={className}>
    <FormDialogrenderer
      title={i18n.t('orderAggregators:common:order.deliveryEditDialogTitle')}
      innerRef={dialogRef}
      renderBody={({ form }) => (
        <DialogBody
          form={form}
          datepickerMin={datepickerMin}
          datepickerMax={datepickerMax}
        />
      )}
      renderFooter={props => <DialogFooter {...props} />}
      initialValues={deliveries}
      onSubmit={onSubmit}
      showCloseAlert={true}
    />
  </div>
);

const commonStyle = css`
  .description {
    .required-sign {
      position: relative;
      ${FontStyles.text7};

      &:after {
        content: ' ';
        position: absolute;
        left: 0;
        bottom: 0;
        border: 0;
        border-top: 1px solid ${Colors.orange1};
        margin-left: 0;
      }
    }

    ul {
      padding-left: 12px;
      margin-top: 8px;

      li {
        position: relative;
        list-style: none;

        &:before {
          position: absolute;
          top: 0.6rem;
          left: -0.7rem;
          content: '';
          display: inline-block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: ${Colors.black1};
        }
      }
    }
  }

  .description-label {
    ${FontStyles.text5};
    margin-top: 40px;
    margin-bottom: 16px;
  }

  .footer-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .delivery {
    padding: 32px 32px 64px;
  }

  .description {
    ${FontStyles.text8};

    .required-sign {
      &:after {
        width: 308px;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .delivery {
    padding: 0;
    margin: 32px 0;

    ${RadioField} {
      margin: 16px;
    }
  }

  .description {
    ${FontStyles.text6};
    padding: 0 16px;

    .required-sign {
      &:after {
        width: 270px;
      }
    }
  }
`;

export default applyStyles(DeliveryDialog)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/DeliveryDialog.js